import { useAppSelector } from 'src/hooks/useStore';
import { GetDefaultCurrency } from 'src/legacy/components/Formatters';
import { arrayToMap } from 'src/utils/array';

export const useDefaultCurrency = () => {
  const { portalDefaultCurrency } = useAppSelector((state) => ({
    portalDefaultCurrency: state.payments.accountInfo?.default_currency,
    companies: arrayToMap(state.clients.companies, 'id'),
  }));

  return portalDefaultCurrency || GetDefaultCurrency();
};
